// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import proposalOutcomeEntity from './entities/proposal-outcome.json';
import proposalOutcomeMenu from '../pages/proposal-outcome/menu.json';
import proposalOutcomeFullForm from '../pages/proposal-outcome/forms/full.json';
import proposalOutcomeContextForm from '../pages/proposal-outcome/forms/context.json';
import proposalOutcomeMiniForm from '../pages/proposal-outcome/forms/mini.json';
import proposalOutcomeLookupForm from '../pages/proposal-outcome/forms/lookup.json';
import proposalOutcomeTableView from '../pages/proposal-outcome/views/table.json';
import proposalOutcomeCardsView from '../pages/proposal-outcome/views/cards.json';
import proposalOutcomeDashboardView from '../pages/proposal-outcome/views/dashboard.json';

/** Тип запису «Результат пропозиції» зі сторінками пакета: меню, форми та подання з pages/proposal-outcome/. */
export const proposalOutcomeDefinition: IRecordTypeDefinition = {
  ...proposalOutcomeEntity,
  views: assembleViewSet({
      table: proposalOutcomeTableView,
      cards: proposalOutcomeCardsView,
      dashboard: proposalOutcomeDashboardView,
  }),
  form: proposalOutcomeFullForm,
  forms: { full: proposalOutcomeFullForm, context: proposalOutcomeContextForm, mini: proposalOutcomeMiniForm, lookup: proposalOutcomeLookupForm },
  menu: proposalOutcomeMenu,
} as IRecordTypeDefinition;
